import { Button, ButtonGroup, Divider } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import ContentConstants from '../../../contentConstants';
import { AudienceSourceType, IAudience, ISurveyAdminSummary, ITrendGroup, ITrendSurvey } from '../../../models';
import { SurveyStatusType } from '../../../models/SurveyStatusType';
import { DistributionHelper } from '../../../utilities/DistributionHelper';
import { IUserFeatureAccessHelper } from '../../../utilities/FeatureFlags';
import { CardLayout, LabelAbove, SaveButtonsContainer } from '../../common';
import { ReportingTrends } from '../reporting-setup/ReportingTrends';

export interface ITrendToProps {
	surveyId: number;
	audiences: IAudience[];
	isLoading: boolean;
	isLoadingTrendSurveys: boolean;
	isSaving: boolean;
	selectedTrendGroupId?: string;
	selectedTrendGroupName: string;
	trendGroups: ITrendGroup[];
	trendSurveys: ITrendSurvey[];
	surveyAdminSummary?: ISurveyAdminSummary;
	userFeatureAccessHelper: IUserFeatureAccessHelper;
	ChangeTrendGroup: (surveyId: number, trendGroupId: string) => void;
	UpdateSelectedTrendGroupId: (surveyId: number, trendGroupId: string) => void;
}

export class AdminTrendTo extends React.Component<ITrendToProps> {
	constructor(props: ITrendToProps) {
		super(props);
		this.save = this.save.bind(this);
		this.isNotOpen = this.isNotOpen.bind(this);
		this.trendFeatureIsDisabled = this.trendFeatureIsDisabled.bind(this);
	}

	public render() {
		const { isLoading, isLoadingTrendSurveys, isSaving, surveyAdminSummary, surveyId } = this.props;

		const hasBeenCancelled = surveyAdminSummary?.surveyStatus === SurveyStatusType.Cancelled;
		const readOnly = this.isNotOpen() || this.trendFeatureIsDisabled();

		return (
			<CardLayout
				title={
					readOnly
						? ContentConstants.SECTIONHEADERS_REPORTING_SETUP_TRENDS_READ_ONLY
						: ContentConstants.SECTIONHEADERS_REPORTING_SETUP_TRENDS
				}
				loading={isLoading}
			>
				{hasBeenCancelled && <LabelAbove type='input' textIsHtml={true} text={ContentConstants.SURVEY_CANCEL_CONTENT_READONLY} />}
				<ReportingTrends
					{...this.props}
					trendSurveysLoading={isLoadingTrendSurveys}
					onTrendGroupChange={(trendGroupId) => this.props.ChangeTrendGroup(surveyId, trendGroupId)}
					disabled={readOnly}
				/>
				<Divider type='dashed' />
				{!readOnly && (
					<SaveButtonsContainer>
						<ButtonGroup type='column'>
							<Button id='SaveChangesButton' color='primary' size='lg' onClick={this.save} disabled={isSaving}>
								{ContentConstants.BUTTON_SAVE_CHANGES}
							</Button>
						</ButtonGroup>
					</SaveButtonsContainer>
				)}
			</CardLayout>
		);
	}

	public save() {
		const { surveyId, selectedTrendGroupId } = this.props;
		if (selectedTrendGroupId) {
			this.props.UpdateSelectedTrendGroupId(surveyId, selectedTrendGroupId);
		}
	}

	private isNotOpen() {
		switch (this.props.surveyAdminSummary?.surveyStatus) {
			case SurveyStatusType.Draft:
			case SurveyStatusType.Scheduled:
			case SurveyStatusType.SchedulingInProgress:
			case SurveyStatusType.SurveyInProgress:
				return false;
			default:
				return true;
		}
	}

	private trendFeatureIsDisabled() {
		const { surveyAdminSummary, userFeatureAccessHelper, audiences } = this.props;

		// Trend Groups is disabled when Bulk Reporting it is available.
		const hasUnique = _.some(audiences, (a) => DistributionHelper.isNotAnonymous(a.distributionType));
		return (
			userFeatureAccessHelper.CanUserAccessFeature('EnableReportingProfiles') &&
			hasUnique &&
			surveyAdminSummary?.audienceSourceType === AudienceSourceType.Hris
		);
	}
}
